//=====================================================
//　G901：初診ページ遷移
//=====================================================
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { useEffect,useContext } from "react";
import { CtxClinicInfo, CtxSystemErr, CtxNewReservation } from "../../utils/Contexts";
import { getApiData } from "../../utils/CallApi";
import { AxiosResponse } from "axios";
import { ConstMsg } from "../../utils/ConstMsg";
import { ReservationType } from "../../utils/ConstCommon";
import { IFDataNewReservation } from "../../utils/UseNewReservation";

export function G901(){

    const history = useHistory();
    const search = useLocation().search;
    const cnr = useContext(CtxNewReservation);
    const cserr = useContext(CtxSystemErr);
    const cci = useContext(CtxClinicInfo);

    const query2 = new URLSearchParams(search);
    const medicalType = query2.get("medicalType") || "";

    useEffect(
        function () {
            // マウントフラグ
            let isMounted = true;

            if (medicalType !== "") {
                const clinicId = cci.data.id;
                let apiUrl = `/c/${clinicId}/medicaltypes`;
                getApiData(apiUrl, {}, function (res: AxiosResponse<any>) {
                    // アンマウント時はstateを更新しないようにする
                    if (isMounted) {
                        if (res?.data) {
                            if (res.status === 200) {
                                const med = res.data[Number(medicalType) - 1];
                                if (med) {
                                    cnr.create(ReservationType.First);
                                    let param: IFDataNewReservation = { menu: med.name };
                                    param.menutime = med.time;
                                    param.medicalTypeId = med.id;
                                    cnr.data.date = undefined;
                                    cnr.update(param);
                                    history.replace("/reservation/date/monthly");
                                } else {
                                    cserr.setErrmess(ConstMsg.EG9010001);
                                }
                            } else if (res.status === 403 || res.status === 404 || res.status >= 500) {
                                cserr.setErrmess(res.data.message);
                            } else {
                                cserr.setErrmess(ConstMsg.EG9990001);
                            }
                        } else {
                            cserr.setErrmess(ConstMsg.EG9990001);
                        }
                    }
                });
            }else{
                cnr.create(ReservationType.First);
                history.replace("/reservation/menu");
            }

            // cleanup関数(Unmount時の処理)
            return () => {
                // マウントオフ
                isMounted = false;
            }
            // エラーメッセージを更新するため、cserrは第2引数から除外する
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[search]
    );

    return null;
}